import Swiper from 'swiper';
import PageComponent from '../../common/component/page-component';

class VerticalVideos extends PageComponent {
	constructor({
								root,
								element,
								buttonNextData = 'buttonNext',
								buttonPrevData = 'buttonPrev'
							}) {
		super({root: root, element: element});
		this.buttonNextData = buttonNextData;
		this.buttonPrevData = buttonPrevData;
	}

	prepare() {
		this.swiper = new Swiper(this.element, {
			slidesPerView: 1,
			spaceBetween: 0,
			breakpoints: {
				768: {
					slidesPerView: 3,
					spaceBetween: 0
				},
				1024: {
					slidesPerView: 4,
					spaceBetween: 0
				}
			},
			wrapperClass: 'slx-verticalVideos__list', //slider.js inconsistency -no dot before class name
			slideClass: 'slx-verticalVideos__item', //slider.js inconsistency -no dot before class name
			navigation: {
				nextEl: '#button-prev',
				prevEl: '#button-next',
			},
		});

		this.listeners.next = this.events.on(this.dataSelector(this.buttonNextData), 'click', this.onNext.bind(this));
		this.listeners.prev = this.events.on(this.dataSelector(this.buttonPrevData), 'click', this.onPrev.bind(this));
	}

	onNext() {
		this.swiper.slideNext();
	}

	onPrev() {
		this.swiper.slidePrev();
	}
}

export default VerticalVideos;
